module.exports = __webpack_public_path__ + "img/instagram.d6d09ae7.svg";